import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { Card, FlatActionList, Page } from "@towersystems/roam-common-native";
import { LayoutNodeType } from "@towersystems/roam-common/lib/generated-types";
import { startCase } from "lodash";
import { useCallback } from "react";
import { FlatList } from "react-native";
import { Spacings, View } from "react-native-ui-lib";
import { CreateQuickKeyRootParamList } from "../../../../types";
import {
  CreateQuickKeyPrerequisites,
  QuickKeyGroup,
  TypeListItem,
  typeListItemToCreateNavigationArgs,
  typeListItemToNodeType,
  useCreateTile,
} from "../../../../utilities/layout";
import {
  defaultLayoutNodeInputValues,
  quickKeyTypesWithForm,
} from "../../../../utilities/layout/constants";
import { quickKeyColors } from "../../../../utilities/quick-keys";
import { quickKeyTypes } from "./constants";

export type CreateQuickKeyTypeListScreenProps = NativeStackScreenProps<
  CreateQuickKeyRootParamList,
  "CreateQuickKeyTypeListScreen"
>;

export function CreateQuickKeyTypeListScreen({
  navigation,
}: CreateQuickKeyTypeListScreenProps) {
  const { config, handleCreateTile } = useCreateTile();

  const renderGroup = useCallback(({ item }: { item: QuickKeyGroup }) => {
    const items = item.typeListItems.map((item) => ({
      isAction: true,
      key: item,
      title: startCase(item.toLowerCase()),
      onPress: () => {
        if (quickKeyTypesWithForm.includes(item)) {
          handleFormNavigate(item);
        } else {
          handleFormlessCreate(item);
        }
      },
    }));

    return (
      <Card title={item.label}>
        <FlatActionList items={items} />
      </Card>
    );
  }, []);

  function handleFormNavigate(typeListItem: TypeListItem) {
    const { screen, params } = typeListItemToCreateNavigationArgs(
      typeListItem
    ) as any;
    navigation.navigate(screen, params);
  }

  function handleFormlessCreate(typeListItem: TypeListItem) {
    const payload = toPayload({ config, typeListItem });

    if (!payload) return;
    handleCreateTile(payload as any);
  }

  return (
    <Page
      title="Create new Quick Key"
      secondaryTitle="Select the type of quick key to create"
      titleContainerStyle={{ alignItems: "center" }}
    >
      <FlatList
        ItemSeparatorComponent={() => (
          <View style={{ marginTop: Spacings.s4, marginBottom: Spacings.s4 }} />
        )}
        renderItem={renderGroup}
        data={quickKeyTypes}
      ></FlatList>
    </Page>
  );
}

type ToPayloadParams = {
  config: CreateQuickKeyPrerequisites | null;
  typeListItem: TypeListItem;
};

function toPayload({ config, typeListItem }: ToPayloadParams) {
  const layoutNodeType = typeListItemToNodeType(typeListItem);

  const common = {
    ...defaultLayoutNodeInputValues,
    ...config,
    type: layoutNodeType,
    color: quickKeyColors.action.background,
  };

  if (layoutNodeType === LayoutNodeType.ACTION) {
    return {
      ...common,
      action: typeListItem,
    };
  } else if (layoutNodeType === LayoutNodeType.PRODUCT) {
    return {
      ...common,
    };
  }
}
